<template>
	<div class="modal fade" id="reportingModal" role="dialog" aria-labelledby="reportingModalLabel" backdrop="static" data-backdrop="static" aria-hidden="true">
		<div class="modal-dialog modal-xl" role="document">
			<div class="modal-content">
				<!-- Контейнер за Kendo popup-и в модала (dropdown/datepicker и т.н.) -->
				<div :id="popupContainerDomId"></div>
				<div class="modal-header">
					<h5 class="modal-title" id="reportingModalLabel">{{ $t("report.title") }}</h5>
					<button type="button" class="close" data-dismiss="modal" aria-label="Close">
						<span aria-hidden="true">&times;</span>
					</button>
				</div>
				<div class="modal-body" v-if="show ">
					<h5 class="w-100 mb-3">{{ $t("report.template") }}</h5>
					<div class="row">
						<div class="loader" v-show="initialLoading"></div>
						<div class="mb-3 col-md-12" v-if="!initialLoading">
							<span class="required">
								<strong>{{ $t("report.category") }}</strong>
							</span>
							<div>
								<Dropdown :items="dropdawnData" v-model="category.id" :height="500" :bindPopup="true" :popupContainerId="popupContainerSelector" @input="onCategoryChange"></Dropdown>
							</div>
						</div>
						<div v-if="reports.length" class="mb-3 col-md-12">
							<span class="required">
								<strong>{{ $t("report.template") }}</strong>
							</span>
							<div>
								<Dropdown :items="reports" v-model="report.id" :height="500" :bindPopup="true" :popupContainerId="popupContainerSelector" @input="onReportChange"></Dropdown>
							</div>
						</div>
						<div class="mb-3 col-md-12" v-if="eventId">
							<h6 class="font-weight-bold mb-3">{{ $t('documentsSettings.documentType') }}</h6>
							<c-select
								v-model="selectedDocumentType"
								:options="documentTypes"
								:clearable="false"
								:searchable="false"
								:open-on-click="true"
								:reduce="option => option.value"
								:label="'text'"
								class="doc-type-select"
							/>
						</div>
                        <div class="col-md-12 mb-3" v-if="lecturers && lecturers.length > 0">
                            <h6 class="font-weight-bold mb-3">{{ $t('registers.events.lecturers.title') }}</h6>
                            <div class="table-responsive">
                                <table class="table table-sm table-hover">
                                    <thead>
                                        <tr>
                                            <th style="width: 50px;"></th>
                                            <th>{{ $t('registers.events.participants.gridHeaders.name') }}</th>
                                            <th>{{ $t('registers.events.participants.gridHeaders.email') }}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="lecturer in lecturers"
                                            :key="lecturer.id"
                                            @click="selectLecturer(lecturer)"
                                            :class="{ 'table-primary': selectedLecturerId === lecturer.id }"
                                            style="cursor: pointer;">
                                            <td>
                                                <vs-radio
                                                    v-model="selectedLecturerId"
                                                    :vs-value="lecturer.id"
                                                    :name="'lecturer_' + _uid"
                                                    style="justify-content: flex-start !important">
                                                </vs-radio>
                                            </td>
                                            <td>{{ isEnVersion ? lecturer.fullNameEn : lecturer.fullName }}</td>
                                            <td>{{ lecturer.email }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div class="mt-2">
                                <button type="button" class="btn btn-sm btn-outline-secondary" @click="clearLecturerSelection" v-if="selectedLecturerId">
                                    {{ $t('buttons.clearSelection') }}
                                </button>
                            </div>
                        </div>
                        <div class="col-md-12" v-else-if="!isLoadingLecturers">
                            <div class="alert alert-info">{{ $t('registers.events.lecturers.noLecturers') }}</div>
                        </div>
					</div>
					<hr />
					<div class="loader" v-show="isLoading"></div>
					<div v-if="!isLoading">
						<div class="row" v-if="report.id && reportParams">
							<h5 class="mb-3 col-md-12">{{ $t("report.params") }}</h5>
							<div v-for="(item, index) in reportParams" :key="index" :hidden="!item.isVisible" class="col-md-6 mb-3">
								<parameter
                                    :item="item"
									:bindPopup="true"
									:popupContainerId="popupContainerSelector"
                                    @loadChild="loadChildParams"
                                />
							</div>
							<hr />
						</div>
						<div class="row" v-if="report.id && reportParams">
							<h5 class="mb-3 col-md-12">{{ $t("report.format") }}</h5>
							<div class="mb-3 col-md-6">
								<span class="required">
									<strong>{{ $t("report.chooseFormat") }}</strong>
								</span>
								<div>
									<Dropdown
                                        :items="formats"
                                        v-model="format"
                                        :nullable="false"
                                        :height="500"
										:bindPopup="true"
										:popupContainerId="popupContainerSelector"
                                    >
                                    </Dropdown>
								</div>
							</div>
							<div class="mb-3 col-md-6">
								<span class="required">
									<strong>{{ $t("report.docTitle") }}</strong>
								</span>
								<div>
									<input type="text" class="form-control" v-model="docTitle" />
									<div class="text-info radio-message mt-1">
										<i class="fa fa-exclamation-circle"></i>
										{{ $t("report.docTitleInfo") }}
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="modal-footer">
					<button class="btn btn-primary mr-1" :disabled="!isValid" @click="onGenerate">{{ $t("report.generate") }}</button>
					<button class="btn btn-secondary" @click="hide">{{$t("buttons.cancel")}}</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Dropdown from '../dropdown/StaticDropdown';
import parameter from './parameter';
import FileService from '../../services/file.service';
import { mapGetters } from "vuex";
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import {
	OrganizationalDocUploadTypeCode,
	getDocumentUploadTypeOptions
} from '@/common/documentUploadTypes';

export default {
	components: {
		Dropdown,
		parameter,
		'c-select': vSelect
	},
	props: {
		show: {
			type: Boolean,
			required: false
		},
		generate: {
			type: Function,
			required: false,
			default: null
		},
		initialValues: {
			type: Object,
			required: false
		}
	},
	data() {
		return {
			isLoading: false,
			controller: 'Reporting',
			clientId: '',
			categories: [],
			dropdawnData: [],
			reports: [],
			formats: [],
			format: '',
			report: {},
			category: {},
			reportParams: null,
			initialLoading: false,
			docTitle: '',
			reportingAuthToken: '',
			isLoadingLecturers: false,
			lecturers: [],
			selectedLecturerId: null,
			selectedDocumentType: OrganizationalDocUploadTypeCode.BusinessTripOrder
		};
	},
	methods: {
		selectLecturer(lecturer) {
			this.selectedLecturerId = lecturer.id;
		},
		clearLecturerSelection() {
			this.selectedLecturerId = null;
		},
		loadLecturers() {
			if (!this.eventId) {
				return;
			}

			this.isLoadingLecturers = true;

			const request = {
				filter: {
					logic: 'and',
					filters: [
						{ field: 'registerEntityId', operator: 'eq', value: this.eventId }
					]
				}
			};

			this.$http
				.post('/api/lectors/lecturersForEvent', request)
				.then(response => {
					const items = response && response.data && response.data.items ? response.data.items : [];
					this.lecturers = items;
				})
				.catch(err => {
					console.error('Грешка при зареждане на преподаватели:', err);
					this.lecturers = [];
				})
				.finally(() => {
					this.isLoadingLecturers = false;
				});
		},
		getClient() {
			this.$http
				.post('/api/Reporting/clients')
				.then(response => {
					// handle success
					this.clientId = response.data.clientId;
				})
				.catch(err =>
					this.$vs.notify({
						color: 'danger',
						title: this.$t('notifications.error'),
						text: this.$helpers.errorText(err)
					})
				);
		},
		getCategories() {
			this.$http
				.get('/api/Reporting/list')
				.then(response => {
					this.categories = response.data;
					this.dropdawnData = this.categories.map(item => ({
						text: item.name,
						id: item.categoryId
					}));
					this.initialLoading = false;
				})
				.catch(err =>
					this.$vs.notify({
						color: 'danger',
						title: this.$t('notifications.error'),
						text: this.$helpers.errorText(err)
					})
				);
		},
		getFormats() {
			this.$http
				.get('/api/Reporting/formats')
				.then(response => {
					// handle success
					this.formats = response.data.map(x => ({ id: x.name, text: `${x.name} - ${x.localizedName}` }));
				})
				.catch(err =>
					this.$vs.notify({
						color: 'danger',
						title: this.$t('notifications.error'),
						text: this.$helpers.errorText(err)
					})
				);
		},
		onCategoryChange(id) {
			this.report.id = null;
			this.report.name = '';
			this.docTitle = '';
			this.reportParams = null;

			if (!id) {
				this.category = {};
				return;
			}

			let cat = this.categories.find(x => x.categoryId === id);

			if (cat) {
				this.category.id = cat.categoryId;
				this.category.name = cat.name;
				this.report = {};
				this.reports = cat.reports.map(x => ({
					text: x.name,
					id: x.reportId
				}));
			} else {
				this.category = {};
			}
		},
		onReportChange(id) {
			if (!id) {
				this.report.id = null;
				this.report.name = '';
				this.docTitle = '';
				this.reportParams = null;
				return;
			}

			this.isLoading = true;
			let selectedReport = this.reports.find(x => x.id === id);

			this.report.id = id;
			this.report.name = this.docTitle = selectedReport.text;
			this.reportParams = null;
			this.loadParams();
		},
		loadParams() {
			this.$http
				.post(`/api/Reporting/clients/${this.clientId}/parameters`, {
					report: `${this.category.name}/${this.report.name}.trdp`,
					parameterValues: {}
				})
				.then(response => {
					// handle success
					this.reportParams = response.data;

					if (this.initialValues) {
						this.setInitialValues();
						this.loadChildParams();
					}

					this.isLoading = false;
				})
				.catch(response => {
					// handle error
					this.isLoading = false;
				});
		},
		loadChildParams() {
			this.$http
				.post(`/api/Reporting/clients/${this.clientId}/parameters`, {
					report: `${this.category.name}/${this.report.name}.trdp`,
					parameterValues: this.params
				})
				.then(response => {
					// handle success
					this.reportParams = response.data;
				})
				.catch(response => {
					// handle error
				});
		},
		setInitialValues() {
			this.reportParams.forEach(item => {
				if (this.initialValues.hasOwnProperty(item.id)) {
					item.value = this.initialValues[item.id];
				}
			});
		},
		onGenerate() {
			let reportData = {
				categoryId: this.category.id,
				categoryName: this.category.name,
				reportId: this.report.id,
				reportName: this.report.name,
				format: this.format,
				title: this.docTitle,
				rawParams: this.reportParams,
				params: this.params,
				metadata: { ...{ categoryName: this.category.name, reportName: this.report.name, format: this.format, title: this.docTitle }, ...this.setMetadata(this.reportParams) },
				documentType: this.selectedDocumentType,
				registerEntityToPersonIds: this.selectedLecturerId ? [this.selectedLecturerId] : []
			};

			if (this.generate) {
				this.generate(reportData);
				this.hide();
			} else {
				this.generateDoc(reportData);
			}
		},
        setMetadata(reportParams) {
            if (!reportParams) return;

            const metadata = {};

            for (const item of reportParams.filter(x => x.isVisible)) {
                if (item.type === 'System.DateTime') {
                    metadata[item.id] = item.value ? this.$moment(item.value).format('DD.MM.YYYY') : ''
                } else if (!item.multivalue && item.availableValues && item.availableValues.length) {
                    metadata[item.id] = item.availableValues.find(x => x.value === item.value).name || '';
                } else if (item.multivalue && item.availableValues && item.availableValues.length) {
                    const selectedValues = item.value || [];
                    metadata[item.id] = item.availableValues
                        .filter(x => selectedValues.includes(x.value))
                        .map(x => x.name);
                } else {
                    metadata[item.id] = item.value;
                }
            }

            return metadata;
        },
		generateDoc(reportData) {
			this.isLoading = true;
			FileService.downloadFilePost(`/api/Reporting/generate`, reportData)
				.then(() => this.$emit('generated', { reportData }))
				.catch(err =>
					this.$vs.notify({
						color: 'danger',
						title: this.$t('notifications.error'),
						text: this.$helpers.errorText(err)
					})
				)
				.then(() => this.hide());
		},
		hide() {
			$(this.$el).modal('hide');
		},
		onClose() {
			this.format = '';
			this.report = {};
			this.category = {};
			this.reportParams = null;
			this.docTitle = '';
			this.isLoading = false;
			this.reports = [];
			this.lecturers = [];
			this.selectedLecturerId = null;
			this.selectedDocumentType = null;
			this.$emit('update:show', false);
			this.$emit('onClose');
		},
		onShow() {
			this.getClient();
		}
	},
	computed: {
		...mapGetters(['reportingServerUrl', 'authToken', 'isEnVersion']),
		popupContainerDomId() {
			return `reportingModalPopupContainer_${this._uid}`;
		},
		popupContainerSelector() {
			return `#${this.popupContainerDomId}`;
		},
		eventId() {
			return this.initialValues && this.initialValues.EventId ? this.initialValues.EventId : null;
		},
		isValid() {
			let isValid = true;
			if (!this.reportParams) {
				isValid = false;
			} else {
				isValid = !this.reportParams.some(item => {
					return !item.allowNull && !item.value;
				});
			}

			return isValid && this.format;
		},
		documentTypes() {
			return getDocumentUploadTypeOptions(this.$i18n);
		},
		params() {
			var params = {};
            this.reportParams.forEach(item => {
                (params[item.id] = item.value)
            });
			return params;
		}
	},
	async mounted() {
		// add modal close listener
		$(this.$el).on('hidden.bs.modal', this.onClose);
		// add modal open listener
		// $(this.$el).on('show.bs.modal', this.onShow);

		this.initialLoading = true;
		this.getClient();
		this.getCategories();
		this.getFormats();
	},
	beforeDestroy() {
		// remove listeners
		$(this.$el).off('hidden.bs.modal');
		$(this.$el).off('show.bs.modal');
	},
	watch: {
		show: function(val) {
			if (val) {
				this.loadLecturers();
			}
			$(this.$el).modal(val ? 'show' : 'hide');
		}
	}
};
</script>

<style lang="scss" scoped>
.doc-type-select ::v-deep .vs__dropdown-toggle {
	min-height: 38px;
	height: 38px;
	padding: 0.375rem 0.75rem;
	border: 1px solid #ced4da;
	border-radius: 0.25rem;
	background-color: #fff;
	box-shadow: none;
	width: 100%;
	cursor: pointer;
}

.doc-type-select ::v-deep .vs__selected-options {
	padding: 0;
	flex: 1 1 auto;
}

.doc-type-select ::v-deep .vs__search,
.doc-type-select ::v-deep .vs__selected {
	margin: 0;
	line-height: 1.5;
	cursor: pointer;
}

.doc-type-select ::v-deep .vs__actions {
	padding: 0;
}

.doc-type-select ::v-deep .vs__open-indicator {
	margin-top: 2px;
}
</style>
